jQuery(document).ready(function () {
  if (jQuery(window).width() < 992) {
    jQuery("#tabBannerContent").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: jQuery(".tab-banner-section .slider-arrow .prev"),
      nextArrow: jQuery(".tab-banner-section .slider-arrow .next"),
    });
  }
  jQuery(".image-text-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
  });

  jQuery(".testimonial-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    prevArrow: jQuery(".testimonial-section .slider-arrow .prev"),
    nextArrow: jQuery(".testimonial-section .slider-arrow .next"),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  jQuery(".images-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    //fade: true,
    autoplay: true,
    prevArrow: jQuery(".images-slider-section .slider-arrow .prev"),
    nextArrow: jQuery(".images-slider-section .slider-arrow .next"),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // jQuery(".tab-image-slider").slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: true,
  //     dots: false,
  //     //fade: true,
  //     autoplay: true,
  //     prevArrow: jQuery(".tab-image-slider-section .slider-arrow .prev"),
  //     nextArrow: jQuery(".tab-image-slider-section .slider-arrow .next")
  // });
  jQuery(".tab-slider-1").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    //fade: true,
    autoplay: true,
    prevArrow: jQuery(".tab-slider-arrow-1 .prev"),
    nextArrow: jQuery(".tab-slider-arrow-1 .next"),
  });
  jQuery(".tab-slider-2").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    //fade: true,
    autoplay: true,
    prevArrow: jQuery(".tab-slider-arrow-2 .prev"),
    nextArrow: jQuery(".tab-slider-arrow-2 .next"),
  });
  jQuery(".tab-slider-3").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    //fade: true,
    autoplay: true,
    prevArrow: jQuery(".tab-slider-arrow-3 .prev"),
    nextArrow: jQuery(".tab-slider-arrow-3 .next"),
  });
  jQuery(".tab-slider-4").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    //fade: true,
    autoplay: true,
    prevArrow: jQuery(".tab-slider-arrow-4 .prev"),
    nextArrow: jQuery(".tab-slider-arrow-4 .next"),
  });
  //   sliderImageWidth();
  //   jQuery("#imageTab").on("toggled", function (event, tab) {
  //     sliderImageWidth();
  //   });
  //   jQuery(window).resize(function () {
  //     sliderImageWidth();
  //   });
});

function sliderImageWidth() {
  var containerWidth = jQuery(".tab-image-slider-section .container").width();
  jQuery(".tab-image-slider-section .image-part picture").width(containerWidth);
}
